export const numberProps = { isStringOnly: true, isCurrency: true }